// extracted by mini-css-extract-plugin
export default {"mainHeader":"main-header_mainHeader__Ft9fe","mainNav":"main-header_mainNav__c0U0H","mainMenu":"main-header_mainMenu__FYFVS"};